<template>
  <div class="agf--flow-page" :class="`agf--flow-page--displayType-${displayType}`">
    <div class="agf--flow-page--header">
      {{ flowPage.card_title }}
    </div>
    <FlowPageBody
      ref="flowPageBody"
      :flow-page="flowPage"
      :flow-variables="flowVariables"
      :page-index="pageIndex"
    />
    <div class="agf--flow-page--body--after">
      <div
        v-if="displayType === 'balloon' && flowPage.illustration"
        class="agf--flow-page--body--after--balloon-image-wrapper"
      >
        <img
          class="agf--flow-page--body--after--balloon-image"
          :src="$core.$imgix?.buildUrl(flowPage.illustration)"
        />
      </div>
    </div>
    <div class="agf--flow-page--footer">
      <button class="back" @click="() => $emit('back')" :disabled="backDisabled">
        {{ backButtonText }}
      </button>
      <button class="next" @click="() => toNext()" :disabled="nextDisabled">
        {{ nextButtonText }}
        <span
          class="agf--flow-page--footer--next-button-note"
          v-if="displayType === 'modal' && flowPage.modal_proceed_button_note"
          >{{ flowPage.modal_proceed_button_note }}</span
        >
      </button>
    </div>
  </div>
</template>
<script lang="ts">
import { PropType } from 'vue'
import { ModelPsFlowPages } from '../../models/fireModels/types'
import { AgreementFlowDefinitionValueTemplateUserDefineItem } from '../AgreementFlowDefinitionInput/AgreementFlowDefinitionInputService'
import { AgreementFlowService } from './AgreementFlowService'
import FlowPageBody from './FlowPageBody.vue'

// 吹き出し型, カード型, 枠なし, モーダル
const classNameByTypes = {
  吹き出し型: 'balloon',
  カード型: 'card',
  枠なし: 'no-frame',
  モーダル: 'modal',
}

export default {
  name: 'FlowPage',
  components: { FlowPageBody },
  emits: ['back', 'next'],
  inject: ['AgreementFlowService'],
  props: {
    pageIndex: {
      type: Number,
      required: true,
    },
    flowPage: {
      type: Object as PropType<ModelPsFlowPages>,
      required: true,
    },
    flowVariables: {
      type: Object as PropType<
        Record<string, AgreementFlowDefinitionValueTemplateUserDefineItem>
      >,
      required: true,
    },
    backDisabled: {
      type: Boolean,
      default: false,
    },
    nextDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    $afs(): AgreementFlowService {
      return this.AgreementFlowService as AgreementFlowService
    },
    displayType() {
      return classNameByTypes[this.flowPage?.display_type || '枠なし']
    },
    nextButtonText() {
      if (this.displayType === 'modal' && this.flowPage.modal_proceed_button_text) {
        return this.flowPage.modal_proceed_button_text
      }
      return '進む'
    },
    backButtonText() {
      if (this.displayType === 'modal' && this.flowPage.modal_back_button_text) {
        return this.flowPage.modal_back_button_text
      }

      return '戻る'
    },
  },
  methods: {
    toNext() {
      // @ts-ignore 現在のページ内に $afs.inputHasErrorClass があるかどうかをチェック
      const bodyHtmlElement = this.$refs.flowPageBody?.$el as HTMLElement
      const hasErrorElems = bodyHtmlElement.querySelectorAll(
        `.${this.$afs.inputHasErrorClass}`,
      )
      if (hasErrorElems.length > 0) {
        // 最初の要素に scrollIntoView する
        hasErrorElems[0].scrollIntoView({
          behavior: 'smooth',
        })
        console.log(`hasErrorElems.length:`, hasErrorElems.length)
        return
      }
      this.$emit('next')
    },
  },
}
</script>
